module.exports = __webpack_public_path__ + "static/Panda3-a53784edb256c31bf07f9dde51538e2e.svg";